import { KolAbbr } from './abbr/shadow';
import { KolAccordion } from './accordion/shadow';
import { KolAlertWc } from './alert/component';
import { KolAlert } from './alert/shadow';
import { KolAvatar } from './avatar/component';
import { KolBadge } from './badge/shadow';
import { KolBreadcrumb } from './breadcrumb/shadow';
import { KolButtonLink } from './button-link/shadow';
import { KolButtonWc } from './button/component';
import { KolButton } from './button/shadow';
import { KolCard } from './card/shadow';
import { KolCombobox } from './combobox/shadow';
import { KolDetails } from './details/shadow';
import { KolDialogWc } from './dialog/component';
import { KolDialog } from './dialog/shadow';
import { KolDrawer } from './drawer/shadow';
import { KolForm } from './form/shadow';
import { KolHeading } from './heading/component';
import { KolIcon } from './icon/component';
import { KolImage } from './image/component';
import { KolInputCheckbox } from './input-checkbox/shadow';
import { KolInputColor } from './input-color/shadow';
import { KolInputDate } from './input-date/shadow';
import { KolInputEmail } from './input-email/shadow';
import { KolInputFile } from './input-file/shadow';
import { KolInputNumber } from './input-number/shadow';
import { KolInputPassword } from './input-password/shadow';
import { KolInputRadio } from './input-radio/shadow';
import { KolInputRange } from './input-range/shadow';
import { KolInputText } from './input-text/shadow';
import { KolKolibri } from './kolibri/shadow';
import { KolLinkButton } from './link-button/shadow';
import { KolLinkWc } from './link/component';
import { KolLink } from './link/shadow';
import { KolMeter } from './meter/component';
import { KolModal } from './modal/shadow';
import { KolNav } from './nav/shadow';
import { KolPagination } from './pagination/shadow';
import { KolPopoverButton } from './popover-button/shadow';
import { KolProgress } from './progress/component';
import { KolQuote } from './quote/component';
import { KolSelect } from './select/shadow';
import { KolSingleSelect } from './single-select/shadow';
import { KolSkipNav } from './skip-nav/shadow';
import { KolSpin } from './spin/component';
import { KolSplitButton } from './split-button/shadow';
import { KolTabs } from './tabs/shadow';
import { KolTextarea } from './textarea/shadow';
import { KolToastContainer } from './toaster/shadow';
import { KolToolbar } from './toolbar/shadow';
import { KolTooltipWc } from './tooltip/component';
import { KolTreeItemWc } from './tree-item/component';
import { KolTreeItem } from './tree-item/shadow';
import { KolTreeWc } from './tree/component';
import { KolTree } from './tree/shadow';
import { KolVersion } from './version/shadow';

export const COMPONENTS = [
	KolAbbr,
	KolAccordion,
	KolAlert,
	KolAlertWc,
	KolAvatar,
	KolBadge,
	KolBreadcrumb,
	KolButton,
	KolButtonLink,
	KolButtonWc,
	KolCard,
	KolCombobox,
	KolDetails,
	KolDialog,
	KolDialogWc,
	KolDrawer,
	KolForm,
	KolHeading,
	KolIcon,
	KolImage,
	KolInputCheckbox,
	KolInputColor,
	KolInputDate,
	KolInputEmail,
	KolInputFile,
	KolInputNumber,
	KolInputPassword,
	KolInputRadio,
	KolInputRange,
	KolInputText,
	KolKolibri,
	KolLink,
	KolLinkButton,
	KolLinkWc,
	KolMeter,
	KolModal,
	KolNav,
	KolPagination,
	KolProgress,
	KolPopoverButton,
	KolQuote,
	KolSelect,
	KolSingleSelect,
	KolSkipNav,
	KolSpin,
	KolSplitButton,
	KolTabs,
	KolTextarea,
	KolToastContainer,
	KolToolbar,
	KolTooltipWc,
	KolTree,
	KolTreeItem,
	KolTreeItemWc,
	KolTreeWc,
	KolVersion,
];
